// extracted by mini-css-extract-plugin
export default {"dates":"styles_dates__N804Y"};